import {SourceApiService} from "./source.api.service";
import {NgModule} from "@angular/core";
import {StoreModule} from "@ngrx/store";
import {sourceInitialState, sourceReducer, ISourceState} from "./source.reducer";
import {sourceFeatureKey} from "./types";
import {EffectsModule} from "@ngrx/effects";
import {SourceEffects} from "./source.effects";
import {SourceService} from "./source.service";

@NgModule({
    imports:[
        StoreModule.forFeature<ISourceState>(sourceFeatureKey, sourceReducer, {
            initialState: sourceInitialState,
        }),
        EffectsModule.forFeature([SourceEffects])
    ],
    providers:[SourceApiService, SourceService]
})
export class StoreSourceModule {}
